import { render } from "./AppPortalMenu.vue?vue&type=template&id=041303b5"
import script from "./AppPortalMenu.vue?vue&type=script&lang=js"
export * from "./AppPortalMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__